<page-header title="LICENSE_SUBCATEGORIES"></page-header>

<div class="subcategories mt-0">
  <app-table
    [isLoading]="isLoading"
    [totalItems]="totalItems"
    [rows]="state.get('data')"
    [columns]="columns"
    [itemsPerPage]="0"
  >
    <ng-template #addonLeft>
      <div class="buttons m-0">
        <a
          [routerLink]="[
            '/admin',
            'license-categories',
            categoryId,
            'subcategories',
            'create'
          ]"
          class="button is-small is-info"
          translationEditableDirective="CREATE_LICENSE_SUBCATEGORY"
          >{{ 'CREATE_LICENSE_SUBCATEGORY' | translate }}</a
        >
      </div>
    </ng-template>
    <ng-template let-row="row" #actionsColumn>
      <div class="buttons">
        <a
          [routerLink]="[
            '/admin/license-categories/',
            categoryId,
            'subcategories',
            row.get('id'),
            'update'
          ]"
          class="button is-small"
          translationEditableDirective="UPDATE"
          >{{ 'UPDATE' | translate }}</a
        >
        <alert
          #deleteAlert
          (confirm)="deleteBusinessSubcategory(row.get('id'))"
          titleTrnKey="ARE_YOU_SURE"
          textTrnKey="YOU_WONT_BE_ABLE_TO_REVERT_THIS"
        />
        <button
          class="button is-danger is-small"
          (click)="deleteAlert.fire()"
          translationEditableDirective="DELETE"
        >
          {{ 'DELETE' | translate }}
        </button>
      </div>
    </ng-template>
  </app-table>
</div>
